import React, {Component} from 'react';

export class AppFooter extends Component {
render = () => <footer id="svs-footer">
        <p>Copyright 2025 Sharp Vision Software</p>
        <p>Version 1.5.0</p>
        </footer>
    
        
    
}